import { render, staticRenderFns } from "./pointsReportIndex.vue?vue&type=template&id=98dd2e8c&"
import script from "./pointsReportIndex.vue?vue&type=script&lang=js&"
export * from "./pointsReportIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports